import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCallback } from 'react';
import TextAreaField from '../TextAreaField';
import TextAreaFieldArray, { type TextAreaFieldArrayProps } from './TextAreaFieldArray';
import { type TranslationDrawerProps, useTranslationMultipleEntryDrawer } from './TranslationDrawer';

export type TranslatedTextAreaFieldProps = TextAreaFieldArrayProps &
    Pick<TranslationDrawerProps, 'languages'> & { title?: string };

const TranslatedTextAreaFieldArray = ({
    name,
    languages,
    disabled,
    onDelete,
    title,
    isDefault,
    withContentRefinement,
    ...props
}: TranslatedTextAreaFieldProps) => {
    const drawer = useTranslationMultipleEntryDrawer();

    const openTranslationDrawer = useCallback(
        (id: number) => {
            drawer.open(id);
        },
        [drawer]
    );

    const renderTextAreaField: TranslationDrawerProps['renderField'] = (translation, onDelete) => {
        const button = <Button icon={<DeleteOutlined />} onClick={onDelete} size="small" type="text" />;

        return (
            <TextAreaField
                key={translation.languagePackId}
                addMoreButton={button}
                label={translation.language.referenceName}
                name={translation.name}
                withContentRefinement={withContentRefinement}
            />
        );
    };

    return (
        <>
            <TextAreaFieldArray
                disabled={disabled}
                name={name}
                {...props}
                isDefault={isDefault}
                onDelete={onDelete}
                openTranslationDrawer={openTranslationDrawer}
                withContentRefinement
            />
            {drawer.render({ name, title: title ?? props.label, languages, renderField: renderTextAreaField })}
        </>
    );
};

export default TranslatedTextAreaFieldArray;
